/*
 * 统一管理从服务端获取的数据，方便后期维护
 * 通过export  暴露封装的获取数据方法
 */
import Axios from "axios";

const industryAnalyze = process.env.VUE_APP_SERVER_URL

//获取北京企业
export const entBJinfosApi = (data) => Axios.get(industryAnalyze + '/ent-bj/infos', data);

//获取北京地区
export const districtsApi = (data) => Axios.get(industryAnalyze + '/dict/district/districts', data);

//获取全部行业
export const industriesApi = (data) => Axios.get(industryAnalyze + '/dict/industry/industries', data);

// 根据ID展示北京市企业信息
export const bjEntApi = (data) => Axios.get(industryAnalyze + '/ent-bj/bjEnt', data);

